import React from "react";
import "./Discount_holder.css";

function Discount_holder({discount}) {
  return (
    <>
      <section className="Discount_holder">
        <p>{discount}%</p>
      </section>
    </>
  );
}

export default Discount_holder;
